/* eslint-disable */

/** unique or primary key constraints on table "argo.context" */
export enum ArgoContextConstraint {
  /** unique or primary key constraint on columns "name" */
  ContextNameKey = 'context_name_key',
  /** unique or primary key constraint on columns "context_id" */
  ContextPkey = 'context_pkey'
}

/** select columns of table "argo.context" */
export enum ArgoContextSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** update columns of table "argo.context" */
export enum ArgoContextUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

